import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { PrimeNG } from 'primeng/config';
import { FileSelectEvent, FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-upload-images',
  standalone: true,
  imports: [
    CommonModule,
    FileUploadModule,
    ButtonModule,
    BadgeModule,
    ToastModule,
    HttpClientModule,
  ],
  providers: [MessageService],
  templateUrl: './upload-images.component.html',
  styleUrl: './upload-images.component.scss',
})
export class UploadImagesComponent {
  private config = inject(PrimeNG);
  private messageService = inject(MessageService);

  maxFiles = input<number>(3);
  initialImages = input<string[]>([]);
  uploadButtonEnabled = input<boolean>(false);
  placeholderContent = input<string>('Arrastra y suelta imágenes aquí.');

  onImagesChange = output<{ initial: string[]; newlyUploaded: any[] }>();

  uploadedPersistedImages = signal<any[]>([]);

  totalCount = computed(() => {
    return this.initialImages().length + this.uploadedPersistedImages().length;
  });

  onSelectedFiles(event: FileSelectEvent) {
    if (!this.uploadButtonEnabled()) {
      this.onTemplatedUpload(event);
    }
  }

  onTemplatedUpload(event: any) {
    const files = event.files;
    this.uploadedPersistedImages.update(current => [...current, ...files]);

    this.emitChanges();
    this.messageService.add({
      severity: 'success',
      summary: 'Completado',
      detail: 'Imágenes guardadas exitosamente',
    });
  }

  removeAllImages() {
    this.uploadedPersistedImages.set([]);
    this.emitChanges();
  }

  removeInitialImage(index: number) {
    // Creamos una copia de las imágenes actuales quitando la que se borra
    const updatedInitial = this.initialImages().filter((_, i) => i !== index);

    // Emitimos el nuevo estado al padre
    this.onImagesChange.emit({
      initial: updatedInitial,
      newlyUploaded: this.uploadedPersistedImages(),
    });
  }

  removePersistedImage(index: number) {
    this.uploadedPersistedImages.update(current => {
      const updated = [...current];
      updated.splice(index, 1);
      return updated;
    });
    this.emitChanges();
  }

  private emitChanges() {
    this.onImagesChange.emit({
      initial: this.initialImages(),
      newlyUploaded: this.uploadedPersistedImages(),
    });
  }

  choose(event: MouseEvent, callback: () => void) {
    callback();
  }

  uploadEvent(callback: () => void) {
    callback();
  }

  formatSize(bytes: number) {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = this.config.translation.fileSizeTypes || [
      'Bytes',
      'KB',
      'MB',
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
